//React Redux
import React, { Component } from 'react'
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';

//Material Components
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from "@material-ui/core/Typography";
import SwipeableViews from 'react-swipeable-views';

//Actions
import { SetHeaderButtons } from '../../actions/headerButtonsActions';
import { GetAllVersions, PutVersion } from '../../actions/versionActions';

//three party package
import Moment from 'moment';



const validate = (values) => {
    const errors = {};
    return errors;
};


const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={1}>
                    <Grid>{children}</Grid>
                </Box>
            )}
        </div>
    );
};


TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};


export class VersionList extends Component {
    constructor(props) {
        super(props)

        this.state = {
            //Tabs
            tabValue: 0,
        }

        //Version Information


    };


    componentDidMount() {
        this.props.cleanVersion();
        this.SetHeaderButtons();

    };

    componentWillUnmount() {
        this.props.SetHeaderButtons(undefined);
    }

    SetHeaderButtons = () => {
        const headerButtons = this.getHeaderButtons();
        this.props.SetHeaderButtons(headerButtons)
    }

    getHeaderButtons = () => {
        const styles = {
            globalActions: {
                marginLeft: 'auto',
                marginRight: '0px'
            },
        }

        return (
            <div style={styles.globalActions}>
                {
                    <div className="blueBottomButon appbtnBarButton" onClick={this.props.AddVersionHandler}
                        id='Add_Version_btn'
                        style={styles.globalActions}>
                        Add Version
                    </div>
                }
            </div>
        )
    }


    resize() {
        this.setState({ isMobile: window.innerWidth <= 960 });

        const sizes = {
            xs: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 600,
            },
            sm: {
                name: 'sm',
                fontSize: '60%',
                maxWidht: 1024,
            },
            md: {
                name: 'md',
                fontSize: '80%',
                maxWidht: 1880,
            },
            lg: {
                name: 'lg',
                fontSize: '100%',
                maxWidht: 1920,
            },
        };

        const windowWidht = window.innerWidth;
        const windowHeiht = window.innerHeight;

        let rootFontSize = sizes.xs;

        if (windowWidht > sizes.md.maxWidht) {
            rootFontSize = sizes.lg;
        } else if (windowWidht > sizes.sm.maxWidht) {
            rootFontSize = sizes.md;
        } else if (windowWidht > sizes.xs.maxWidht) {
            rootFontSize = sizes.sm;
        } else {
            rootFontSize = sizes.xs;
        }


        this.setState({
            rootFontSize: rootFontSize,
            windowWidht: windowWidht,
            windowHeiht: windowHeiht,
        });
    }

    //#region  TABPANEL
    handleChangeIndex = (index) => {
        this.setState({ tabValue: index })
    };

    handleTabChange = (event, newValue) => {
        this.handleChangeIndex(newValue);
    };


    a11yProps = (index) => {
        return {
            id: `full-width-tab-${index}`,
            'aria-controls': `full-width-tabpanel-${index}`,
        };
    };
    //#endregion


    //#region HADLERS
    toggleAprovedVersionStateHandler = async (versionObj, newState) => {
        try {
            const newVersionObj = Object.assign({}, versionObj);

            newVersionObj.aproved = newState;

            const resp = await this.props.PutVersion(newVersionObj._id, newVersionObj)
            if (resp.ok) {
                await this.props.GetAllVersions();
            }

        } catch (err) { }
    }
    //#endregion

    //#region  INNER COMPONENTS
    VersionRowComponent = ({ versionObj }) => {
        try {

            //#region Styles
            const styles = {
                rowStyles: {
                    minHeight: '5rem',
                    backgroundColor: '#1f1f1f',
                    color: 'white',
                    borderRadius: '12px',
                    padding: '5px 10px'
                },
                rowContainerStyles: {
                    margin: '10px 0px',
                },
            }
            //#endregion

            return (
                <Grid item container xs={12} style={{ ...styles.rowContainerStyles }} id={`Version_row_${versionObj._id}`}>
                    <Grid item container xs={12} style={{ ...styles.rowStyles }} onClick={() => this.props.openEditVersionPageHandler(versionObj)}>
                        <Grid item container xs={12} md={6} lg={8} style={{ ...styles.columnStyles }}>
                            <this.VersionComponent versionObj={versionObj} />
                        </Grid>
                        <Grid item container xs={12} md={4} lg={3} style={{ ...styles.columnStyles }}>
                            <this.ReleaseDateComponent versionObj={versionObj} />
                        </Grid>
                        <Grid item container xs={12} md={2} lg={1} style={{ ...styles.columnStyles }}>
                            <this.AprovedComponent versionObj={versionObj} />
                        </Grid>
                    </Grid>
                </Grid>
            )
        } catch (err) {
            return (<Grid item container></Grid>)
        }
    };

    VersionComponent = ({ versionObj }) => {
        try {

            if (!versionObj)
                throw new Error('No versinObj');

            const latestVersion = (versionObj.version && versionObj.version.latestVersion) ? versionObj.version.latestVersion : '###';
            const description = (versionObj && versionObj.description) ? versionObj.description : '';

            //#region 
            const styles = {
                versionStyle: {
                    fontSize: '25px',
                },
                descriptionStyles: {
                    fontSize: '15px',
                },

            }
            //#endregion

            return (
                <Grid item container style={{}} key={'VersionComponent' + versionObj._id} >
                    <Grid item container style={{ ...styles.versionStyle }}>{`Version: ${latestVersion}`}</Grid>
                    <Grid item className='rowEngageStyle' style={{ ...styles.descriptionStyles, }}>{`${description}`}</Grid>
                </Grid>
            )
        } catch (err) {
            return (<Grid item container></Grid>)
        }
    };

    ReleaseDateComponent = ({ versionObj }) => {

        try {
            if (!versionObj)
                throw new Error('No versinObj');

            //#region  styles
            const styles = {
                releaseDateStyle: {
                    fontSize: '25px',
                },
                dateStyles: {
                    fontSize: '15px'
                }
            }
            //#endregion

            const releaseDate = (versionObj && versionObj.createdAt) ? Moment(versionObj.createdAt).format('MMMM D, yyyy') : undefined;

            const date = releaseDate ? releaseDate : '';
            return (
                <Grid item container style={{}} key={'VersionComponent' + versionObj._id} >
                    <Grid item container style={{ ...styles.releaseDateStyle }}>{'Release Date'}</Grid>
                    <Grid item container style={{ ...styles.dateStyles }}>{`${date}`}</Grid>
                </Grid>
            )
        } catch (err) {
            return (<Grid item container></Grid>)
        }
    };

    AprovedComponent = ({ versionObj }) => {
        try {
            if (!versionObj)
                throw new Error('No versinObj');

            //#region Styles
            const styles = {
                aprovedStyles: {
                    fontSize: '25px'
                }
            }
            //#endregion

            const classForCheckBox = versionObj.aproved ? 'isChecked' : '';

            return (
                <Grid item container key={'AprovedComponent' + versionObj._id} >
                    <Grid item container justify='center' alignContent='center'>
                        <Grid item style={{ ...styles.aprovedStyles }}>
                            Approved
                        </Grid>
                    </Grid>
                    <Grid item container justify='center'>
                        <Grid item>
                            <Checkbox
                                id={`Version_row_checkbox_${versionObj._id}`}
                                onClick={(e) => e.stopPropagation()}
                                checked={versionObj.aproved}
                                onChange={() => this.toggleAprovedVersionStateHandler(versionObj, !versionObj.aproved)}
                                name={'checkBox' + versionObj._id}
                                key={'checkBox' + versionObj._id}
                                className={classForCheckBox}

                            />
                        </Grid>
                    </Grid>
                </Grid>
            )
        } catch (err) {
            return (<Grid item container></Grid>)
        }
    };
    //#endregion


    render() {

        return (
            <React.Fragment>
                <AppBar position="static" className="dark">
                    <Toolbar>
                        <Typography variant="h6" >
                            <div id='version_Chevronlist_VersionList' className="engage-nav ToolbalCommunityName">
                                Version List
                            </div>
                        </Typography>
                    </Toolbar>
                </AppBar>
                <main style={{ flexGrow: '1', padding: '7px 20px', zIndex: '1300' }}>
                    <Grid container style={{ width: '100%', margin: '0', padding: '0' }}>
                        <AppBar className='tabStyle' position="static" style={{ width: '100%', margin: '0', padding: '0', backgroundColor: '#2a2a2b' }} color="default" elevation={0} classes={{ root: 'Activity10' }}>
                            <Tabs
                                value={this.state.tabValue}
                                onChange={this.handleTabChange}
                                TabIndicatorProps={{ style: { backgroundColor: 'transparent' } }}
                                variant="fullWidth"
                                aria-label="full width tabs community"
                            >
                                <Tab id='Version_list_staging_tab' label="Staging" className={(this.state.tabValue === 0) ? "SelectedTabStyle" : "tabStyle"} {...this.a11yProps(0)} disableRipple={true} disableFocusRipple={true} />
                                <Tab id='Version_list_production_tab' label="Production" className={(this.state.tabValue === 1) ? "SelectedTabStyle" : "tabStyle"} {...this.a11yProps(1)} disableRipple={true} disableFocusRipple={true} />
                            </Tabs>
                        </AppBar>
                        <SwipeableViews
                            axis={'x'}
                            index={this.state.tabValue}
                            onChangeIndex={this.handleChangeIndex}
                            className="swipeableViews"
                        >
                            <TabPanel value={this.state.tabValue} index={0} dir={'x'}  >
                                <Grid container style={{ marginTop: '30px' }} justify='space-around'  >
                                    <Grid item container>
                                        {
                                            this.props && this.props.stagingVersions && this.props.stagingVersions.length > 0 ?
                                                this.props.stagingVersions.map(versionObj => (
                                                    <this.VersionRowComponent key={`listversionObj_${versionObj._id}`} versionObj={versionObj} />
                                                ))
                                                :
                                                <Grid item container xs={12}>No versions available</Grid>
                                        }
                                    </Grid>
                                </Grid>
                            </TabPanel>
                            <TabPanel value={this.state.tabValue} index={1} dir={'x'}  >
                                <Grid container style={{ marginTop: '30px' }} justify='space-around'  >
                                    <Grid item container >
                                        {
                                            this.props && this.props.productionVersions && this.props.productionVersions.length > 0 ?
                                                this.props.productionVersions.map(versionObj => (
                                                    <this.VersionRowComponent key={`listversionObj_${versionObj._id}`} versionObj={versionObj} />
                                                ))
                                                :
                                                <Grid item container xs={12}>No versions available</Grid>
                                        }
                                    </Grid>
                                </Grid>
                            </TabPanel>
                        </SwipeableViews>
                    </Grid>

                </main>
            </React.Fragment>


        )

    }
}


function mapStateToProps(state) {
    return {

    }

};




export default connect(
    mapStateToProps,
    {
        SetHeaderButtons,
        GetAllVersions,
        PutVersion,
    }
)
    (reduxForm({
        form: 'VersionListingForm',
        validate,
        enableReinitialize: true,
    })(VersionList));